class ImageAiForm {
	constructor(config) {
		this.config = Object.assign({
			card: '[data-image-ai="card"]',
			form: '#image-ai-form',
			mailForm: '[data-image-ai="mail-form"]',
			mailSubmit: '[data-image-ai="mail-submit"]',
			mailSuccess: '[data-image-ai="mail-success"]',
			mailSuccessText: '[data-image-ai="mail-success-text"]',
			mailError: '[data-image-ai="mail-error"]',
			regenerateForm: '[data-image-ai="regenerate-form"]',
			feedbackForm: '[data-image-ai="feedback-form"]',
			feedbackButton: '[data-image-ai="feedback-button"]',
			feedbackMessage: '[data-image-ai="feedback-message"]',
			instructions: '[data-image-ai="instructions"]',
			resultId: '[data-image-ai="result-id"]',
			photo: '[data-image-ai="photo"]',
			dropzone: '[data-image-ai="dropzone"]',
			preview: '[data-image-ai="preview"]',
			resultImage: '[data-image-ai="result-image"]',
			resultLink: '[data-image-ai="result-link"]',
			error: '[data-image-ai="error"]',
			status: '[data-image-ai="status"]',
			changePhoto: '[data-image-ai="change-photo"]',
			bar: '.sl-bar',
			defaultDuration: 30000,
			generatingClass: 'is-generating',
			hasImageClass: 'has-image',
			hasResultClass: 'has-result',
			dragoverClass: 'is-dragover',
			visibleClass: 'is-visible',
			sendingClass: 'is-sending',
			activeClass: 'is-active',
			errorClass: 'is-error',
		}, config);

		// delegated events zodat het formulier ook werkt wanneer het via ajax (opnieuw) geplaatst wordt
		jQuery(document).on('submit', this.config.form, this.submit.bind(this));
		jQuery(document).on('submit', this.config.mailForm, this.submitMail.bind(this));
		jQuery(document).on('submit', this.config.regenerateForm, this.submitRegenerate.bind(this));
		jQuery(document).on('click', this.config.feedbackButton, this.submitFeedback.bind(this));
		jQuery(document).on('change', this.config.photo, this.photoChanged.bind(this));
		jQuery(document).on('dragover', this.config.dropzone, this.dragOver.bind(this));
		jQuery(document).on('dragleave dragend', this.config.dropzone, this.dragLeave.bind(this));
		jQuery(document).on('drop', this.config.dropzone, this.drop.bind(this));
		jQuery(document).on('click', this.config.changePhoto, this.changePhoto.bind(this));
	}

	submit(event) {
		event.preventDefault();
		this.generate(event.currentTarget, false);
	}

	// bijsturen bouwt voort op het laatste resultaat; bij een fout blijft dat resultaat staan
	submitRegenerate(event) {
		event.preventDefault();
		this.generate(event.currentTarget, true);
	}

	generate(form, keepResultOnError) {
		if (!form.checkValidity()) {
			form.reportValidity();
			return;
		}

		this.getRecaptchaToken((token) => {
			let data = new FormData(form);
			if (token) {
				data.set('recaptcha_token', token);
			}

			let $card = this.getCard(jQuery(form));
			// meldingen en de verwachte duur staan op het genereer-formulier
			let $form = $card.find(this.config.form);
			$card.find(this.config.error).addClass('d-none');
			$card.find(this.config.resultLink).addClass('d-none').removeClass(this.config.visibleClass);
			$card.removeClass(this.config.hasResultClass).addClass(this.config.generatingClass);
			$form.attr('aria-busy', 'true');
			this.setStatus($form, $form.data('image-ai-generating-message'));
			this.resetMailForm($card);
			this.resetFeedback($card);
			this.startProgress($form);

			jQuery.ajax({
				url: form.getAttribute('action') || window.location.href,
				method: 'POST',
				data: data,
				processData: false,
				contentType: false,
				success: (response) => {
					$card.removeClass(this.config.generatingClass).addClass(this.config.hasResultClass);
					$card.find(this.config.resultId).val(response.result_id || '');
					$card.find(this.config.instructions).val('');
					let $link = $card.find(this.config.resultLink).attr('href', response.image).removeClass('d-none');
					let image = $card.find(this.config.resultImage).get(0);

					// pas infaden zodra de afbeelding geladen is
					jQuery(image).one('load error', () => $link.addClass(this.config.visibleClass));
					image.src = response.image;
					this.setStatus($form, $form.data('image-ai-generated-message'));
				},
				error: (xhr) => {
					$card.removeClass(this.config.generatingClass);
					if (keepResultOnError) {
						$card.find(this.config.resultLink).removeClass('d-none').addClass(this.config.visibleClass);
						$card.addClass(this.config.hasResultClass);
					}
					// foutmelding gaat via de role="alert", status leegmaken
					this.setStatus($form, '');
					$card.find(this.config.error).text(this.getErrorMessage(xhr, $form)).removeClass('d-none');
				},
				complete: () => {
					$form.removeAttr('aria-busy');
					this.stopProgress($form);
				}
			});
		});
	}

	submitMail(event) {
		event.preventDefault();
		let form = event.currentTarget;

		if (!form.checkValidity()) {
			form.reportValidity();
			return;
		}

		this.getRecaptchaToken((token) => {
			let data = new FormData(form);
			if (token) {
				data.set('recaptcha_token', token);
			}

			let $form = jQuery(form);
			let $button = $form.find(this.config.mailSubmit).prop('disabled', true);
			$form.find(this.config.mailSuccess + ', ' + this.config.mailError).addClass('d-none');
			$form.addClass(this.config.sendingClass).attr('aria-busy', 'true');

			jQuery.ajax({
				url: form.getAttribute('action') || window.location.href,
				method: 'POST',
				data: data,
				processData: false,
				contentType: false,
				success: (response) => {
					$form.find(this.config.mailSuccessText).text(response.message || '');
					$form.find(this.config.mailSuccess).removeClass('d-none');
				},
				error: (xhr) => {
					$form.find(this.config.mailError).text(this.getErrorMessage(xhr, $form)).removeClass('d-none');
				},
				complete: () => {
					$button.prop('disabled', false);
					$form.removeClass(this.config.sendingClass).removeAttr('aria-busy');
				}
			});
		});
	}

	// een klik op like/dislike slaat de keuze direct op; nogmaals klikken op de actieve keuze doet niets
	submitFeedback(event) {
		event.preventDefault();
		let $button = jQuery(event.currentTarget);
		let form = $button.closest(this.config.feedbackForm).get(0);

		if ($button.hasClass(this.config.activeClass) || form.getAttribute('aria-busy') === 'true') {
			return;
		}

		let data = new FormData(form);
		data.set('feedback', $button.val());

		let $form = jQuery(form);
		let $buttons = $form.find(this.config.feedbackButton).prop('disabled', true);
		let $message = $form.find(this.config.feedbackMessage).addClass('d-none').removeClass(this.config.errorClass).text('');
		$form.attr('aria-busy', 'true');

		jQuery.ajax({
			url: form.getAttribute('action') || window.location.href,
			method: 'POST',
			data: data,
			processData: false,
			contentType: false,
			success: (response) => {
				$buttons.removeClass(this.config.activeClass).attr('aria-pressed', 'false');
				$buttons.filter('[value="' + response.feedback + '"]').addClass(this.config.activeClass).attr('aria-pressed', 'true');
				$message.text(response.message || '').removeClass('d-none');
			},
			error: (xhr) => {
				$message.text(this.getErrorMessage(xhr, $form)).addClass(this.config.errorClass).removeClass('d-none');
			},
			complete: () => {
				$buttons.prop('disabled', false);
				$form.removeAttr('aria-busy');
			}
		});
	}

	// de feedback hoort bij één resultaat; bij een nieuwe generatie of foto begint de keuze leeg
	resetFeedback($card) {
		$card.find(this.config.feedbackButton).removeClass(this.config.activeClass).attr('aria-pressed', 'false');
		$card.find(this.config.feedbackMessage).addClass('d-none').removeClass(this.config.errorClass).text('');
	}

	// meldingen van een vorig resultaat horen niet bij een nieuwe generatie; de result-id's blijven staan
	// tot het nieuwe resultaat er is, zodat bijsturen na een mislukte poging nog op het vorige resultaat werkt
	resetMailForm($card) {
		$card.find(this.config.mailSuccess + ', ' + this.config.mailError).addClass('d-none');
		$card.find(this.config.mailSuccessText + ', ' + this.config.mailError).text('');
	}

	getErrorMessage(xhr, $form) {
		return (xhr.responseJSON && xhr.responseJSON.message)
			|| $form.data('image-ai-error-message')
			|| 'Er is iets misgegaan, probeer het opnieuw.';
	}

	getCard($element) {
		return $element.closest(this.config.card);
	}

	// vult de balk naar 100% in de gemiddelde duur van de laatste generaties (via de view composer)
	startProgress($form) {
		let duration = parseInt($form.data('image-ai-expected-duration'), 10) || this.config.defaultDuration;
		let bar = $form.find(this.config.bar).get(0);
		if (!bar) {
			return;
		}
		bar.style.transition = 'none';
		bar.style.width = '0%';
		bar.offsetWidth; // reflow zodat de transition opnieuw start
		bar.style.transition = 'width ' + duration + 'ms ease-out';
		bar.style.width = '100%';
	}

	stopProgress($form) {
		let bar = $form.find(this.config.bar).get(0);
		if (bar) {
			bar.style.transition = 'none';
			bar.style.width = '0%';
		}
	}

	setStatus($form, message) {
		$form.find(this.config.status).text(message || '');
	}

	changePhoto(event) {
		jQuery(event.currentTarget).closest(this.config.form).find(this.config.photo).trigger('click');
	}

	photoChanged(event) {
		let input = event.currentTarget;
		let $form = jQuery(input).closest(this.config.form);
		let $card = this.getCard($form);
		let $preview = $form.find(this.config.preview);

		if (this.previewUrl) {
			URL.revokeObjectURL(this.previewUrl);
			this.previewUrl = null;
		}

		if (!input.files.length) {
			$preview.addClass('d-none').attr('src', '');
			$card.removeClass(this.config.hasImageClass);
			return;
		}

		this.previewUrl = URL.createObjectURL(input.files[0]);
		$preview.attr('src', this.previewUrl).removeClass('d-none');
		$form.find(this.config.resultLink).addClass('d-none').removeClass(this.config.visibleClass);
		$form.find(this.config.error).addClass('d-none');
		this.setStatus($form, '');
		this.resetMailForm($card);
		this.resetFeedback($card);
		$card.find(this.config.resultId).val('');
		$card.find(this.config.instructions).val('');
		$card.removeClass(this.config.hasResultClass).addClass(this.config.hasImageClass);
	}

	dragOver(event) {
		// preventDefault is nodig om de drop toe te staan
		event.preventDefault();
		jQuery(event.currentTarget).addClass(this.config.dragoverClass);
	}

	dragLeave(event) {
		jQuery(event.currentTarget).removeClass(this.config.dragoverClass);
	}

	drop(event) {
		event.preventDefault();
		let $dropzone = jQuery(event.currentTarget).removeClass(this.config.dragoverClass);
		let $form = $dropzone.closest(this.config.form);
		let file = (event.originalEvent.dataTransfer.files || [])[0];

		if (!file) {
			return;
		}

		if (!file.type.startsWith('image/')) {
			let message = $form.data('image-ai-invalid-file-message') || 'Alleen afbeeldingen zijn toegestaan.';
			$form.find(this.config.error).text(message).removeClass('d-none');
			return;
		}

		let transfer = new DataTransfer();
		transfer.items.add(file);

		let input = $form.find(this.config.photo).get(0);
		input.files = transfer.files;
		jQuery(input).trigger('change');
	}

	getRecaptchaToken(callback) {
		if (typeof grecaptcha === 'undefined') {
			callback(null);
			return;
		}
		grecaptcha.ready(function() {
			grecaptcha.execute(jQuery('meta[name="recaptcha_client_id"]').attr('content'), {action: 'submit'})
				.then(callback)
				.catch(function() { callback(null); });
		});
	}
}

export default ImageAiForm;
